import { Title } from "../../../../../components/Title";
import claimPayIcon from '../../../../../assets/claim-pay-icon.svg';

export const DrawItemsTitle = () => <Title title='Draw Items (Optional)'>
  <img alt='claimpay' src={claimPayIcon} />
</Title>